/* eslint-disable import/no-cycle */
/* eslint-disable react/no-danger */
import React from 'react';
import IllnessJPG from '@assets/images/illness.jpg';
import IllnessMobileJPG from '@assets/images/illness-mobile.jpg';
import { ContainerSmall } from '~/utils/styles/utils';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';
import { useTranslationContext } from '~/pages/karpaltunnelsyndrom';
import { useTranslationContext as useTranslationContextEn } from '~/pages/en/carpal-tunnel-syndrome';

const CarpalTunnelPage: React.FC = () => {
  const t = useTranslationContext();
  const tEn = useTranslationContextEn();

  return (
    <>
      <HeaderFooterLayout
        desktopHero={IllnessJPG}
        mobileHero={IllnessMobileJPG}
        altHero="Modell eines Gehirns zur Krankheitserklärung."
        deLink="/karpaltunnelsyndrom/"
        enLink="/en/carpal-tunnel-syndrome/"
      >
        <ContainerSmall>
          <div
            dangerouslySetInnerHTML={{
              __html: t('CarpalContent1') || tEn('CarpalContent1'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('CarpalContent2') || tEn('CarpalContent2'),
            }}
          />
        </ContainerSmall>
      </HeaderFooterLayout>
    </>
  );
};

export default CarpalTunnelPage;
